<p class="bdcpy">Are you sure you want to remove this item from your order?</p>